/* tslint:disable interface-name */
declare interface Targetings {
  article_tags?: string | string[]
  article_seq?: number
}

declare interface GamWindow extends Window {
  googletag: googletag.Googletag
}

declare var window: GamWindow

export default class GoogleAdManager {
  // 広告配信のための処理
  //
  // @params adUnitPath Full path of the ad unit with the network code and unit code.
  // @params size       Width and height of the added slot.
  // @params optDiv     ID of the div that will contain this ad unit.
  public static deliver(
    adUnitPath: string,
    size: googletag.GeneralSize,
    optDiv: string,
    targetings?: Targetings
  ) {
    window.googletag = window.googletag || ({ cmd: [] } as any)

    this.defineSlot(adUnitPath, size, optDiv, targetings)
    this.displayAdWithCheckingDOMState(optDiv)
  }

  // 広告枠の定義をする
  private static defineSlot(adUnitPath, size, optDiv, targetings?) {
    googletag.cmd.push(() => {
      const slot = googletag.defineSlot(adUnitPath, size, optDiv)

      if (targetings) {
        Object.keys(targetings).forEach(key => {
          slot.setTargeting(key, targetings[key])
        })
      }

      slot.addService(googletag.pubads())
      googletag.pubads().enableSingleRequest()
      googletag.pubads().collapseEmptyDivs()
      googletag.enableServices()
    })
  }

  // 広告枠に広告を表示する
  private static displayAd(optDiv: string) {
    googletag.cmd.push(() => {
      googletag.display(optDiv)
    })
  }

  // 広告枠 (DOM) の状態を加味して広告を表示する
  private static displayAdWithCheckingDOMState(optDiv: string) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.displayAd(optDiv)
      })
    } else {
      this.displayAd(optDiv)
    }
  }
}
